import { API_CONFIG, getPangoUrl, getPangoHeaders } from '../config/api';
import { MissionsResponse, Mission, MissionSummary } from '../types/mission';

class MissionApiService {
  /**
   * Get missions for a specific outlet
   */
  async getMissions(outletId: string): Promise<MissionsResponse> {
    try {
      const endpoint = API_CONFIG.PANGO.ENDPOINTS.MISSIONS.GET_MISSIONS.replace('{outletId}', outletId);
      const url = getPangoUrl(endpoint);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getPangoHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get mission summary stats for Welcome page
   */
  async getMissionStats(outletId: string): Promise<MissionSummary | null> {
    try {
      const response = await this.getMissions(outletId);
      if (response.success && response.data?.recommended_missions?.summary) {
        return response.data.recommended_missions.summary;
      }
      return null;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get all available missions (not started)
   */
  async getAvailableMissions(outletId: string): Promise<Mission[]> {
    try {
      const response = await this.getMissions(outletId);
      if (response.success && response.data?.recommended_missions?.not_started) {
        return response.data.recommended_missions.not_started;
      }
      return [];
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get missions in progress
   */
  async getInProgressMissions(outletId: string): Promise<Mission[]> {
    try {
      const response = await this.getMissions(outletId);
      if (response.success && response.data?.recommended_missions?.in_progress) {
        return response.data.recommended_missions.in_progress;
      }
      return [];
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get all missions (available + in progress)
   */
  async getAllMissions(outletId: string): Promise<Mission[]> {
    try {
      const response = await this.getMissions(outletId);
      if (response.success && response.data?.recommended_missions) {
        const { not_started, in_progress } = response.data.recommended_missions;
        return [...(not_started || []), ...(in_progress || [])];
      }
      return [];
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get AI message for missions
   */
  async getMissionMessage(outletId: string, contactName?: string): Promise<string> {
    try {
      const response = await this.getMissions(outletId);
      if (response.success && response.data?.ai_message) {
        let message = response.data.ai_message;
        
        // Replace outlet name with contact name if provided
        if (contactName && response.data?.outlet?.name) {
          message = message.replace(response.data.outlet.name, contactName);
        }
        
        return message;
      }
      return 'Chào bạn! Hãy tham gia các nhiệm vụ để tích lũy điểm thưởng nhé!';
    } catch (error) {
      return 'Chào bạn! Hãy tham gia các nhiệm vụ để tích lũy điểm thưởng nhé!';
    }
  }
}

export const missionApi = new MissionApiService();
